document.querySelectorAll('.image-or-video .figure-wrapper.has-video').forEach(function (figure) {
    var poster = figure.querySelector('.video-poster');
    var video = figure.querySelector('video');

    if (!poster || !video) {
        return;
    }

    poster.addEventListener('click', function () {
        figure.classList.add('is-playing');
        video.setAttribute('controls', '');
        video.play();
    });
});